module.exports = __webpack_public_path__ + "media/src/images/icon/carousel-control-next-13d96eed96e6ba9afcbb77db09ac7d9a.svg";